import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

// Constants
import { SYDLEClientID } from '../../shared/constants/one-constants';

// Enums
import { Dtm, getDtm } from '../../shared/enum/dtm';

// Models
import { CheckoutSuccessData } from '../../shared/model/checkout-success-data';

// Services
import { CheckoutService } from '../../shared/services/checkout.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { DtmService } from '../../services/dtm.service';
import { SessionStorageService } from '../../shared/services/session-storage.service';

import { HttpService } from "../../shared/services/http.service";
import { MatDialog } from "@angular/material/dialog";
import { DialogAlertComponent } from "../../shared/components/dialog-alert/dialog-alert.component";
import { Api } from "../../shared/enum/Api";

import { UtilsService } from "src/app/shared/services/utils.service";
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { DialogData } from 'src/app/shared/model/dialog-data';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'pme-checkout-success',
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CheckoutSuccessComponent implements OnInit, OnDestroy {
  checkoutSuccessData: CheckoutSuccessData;

  // HTML Info
  paymentMethod: string;
  totalValue: number;
  code: string;
  brand: string;
  redirectUrlSecondary: string;
  buttonCTASecondary: string;

  buttonName = 'Ver meu relatório';

  // Provisioning Parameters variables
  userId: string;
  businessId: string;
  heroData: any = {};
  couponAmount: number;
  showHero: boolean;
  classificationIdentifier: string;

  isTelevendas: boolean;
  salesPerson: string = "";

  isItpPayment: boolean = false;
  itpPaymentError: boolean = false;
  paymentInitiationId: string = "";
  finalBalanceTrust: number;
  balanceExpirationDate: any;
  totalDebitTrust: number;
  constructor(
    private snackBarService: SnackBarService,
    private checkoutService: CheckoutService,
    public dtmService: DtmService,
    private sessionStorageService: SessionStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private httpService: HttpService,
    public dialog: MatDialog,
    private breadcrumb: BreadcrumbService,
    public utils: UtilsService,
    private cookieService: CookieService,
  ) {
    breadcrumb.addBreadcrumb("Sucesso");
    breadcrumb.disableBreadcrumb();
    // Adobe Analytics - Padronizacao Setembro/2020
    this.route.queryParams.subscribe((params) => {
      if (params.userId && params.businessId) {
        this.sessionStorageService.setUserIdAndBusinessId(params.userId, params.businessId);
      }
      // Remove query params
      /*verificar se isso realmente é necessário*/
      this.router.navigate([], {
        queryParams: {
          'cs': null,
          'ref': null,
          'internalReference': null
        },
        queryParamsHandling: 'merge'
      });
    })
    if (!this.checkoutService.getCheckoutSuccessData()) {
      this.checkoutService.getSessionCheckoutSuccessData();
    }
    this.checkoutSuccessData = this.checkoutService.getCheckoutSuccessData();
    this.classificationIdentifier = this.checkoutSuccessData.contract.product.classificationIdentifier;
    const isVendaDeslogada = sessionStorage.getItem('vendaDeslogada') !== "true";
    this.isTelevendas = JSON.parse(sessionStorage.getItem('isTelevendas'));
    let params;
    // let mapped = getDtm(this.isTelevendas ? Dtm.Sucesso.replace("SYDLE", "SYDLE:TELEVENDAS") : Dtm.Sucesso, this.classificationIdentifier);
    if (this.isTelevendas) {
      params = Dtm.PagamentoReconhecido.replace("SYDLE", "SYDLE:TELEVENDAS");
    } else {
      params = Dtm.PagamentoReconhecido;
    }
    let mapped = getDtm(params, this.classificationIdentifier);

    let dtm = Dtm.PagamentoReconhecido;
    this.dtmService.pageLoaded(dtm, isVendaDeslogada, mapped);

    // Analytics - Checkout comum ou de retencao por saldo insuficiente
    let checkout = 'Sydle';
    let retentionCount = sessionStorage.getItem('retentionCount');
    if (retentionCount && Number(retentionCount) > 0) {
      checkout = 'Sydle-SaldoInsuficiente'
    }
    this.dtmService.customLoaded(['Purchase', 'Transaction'], checkout);

    // Gets the UserID and BusinessId from SessionStorage
    this.getProvisioningParametersFromSessionStorage();

  }

  ngOnInit() {
    if (this.classificationIdentifier === "plano-mensal") {
      this.cookieService.delete('subscriptionPlansType', '/', 'serasaempreendedor.com.br'); // Limpa o cookie usado para encaminhar pra vitrine híbrida
    }
    if (!this.checkoutService.getCheckoutSuccessData()) {
      this.ngOnDestroy();
    } else {
      let successRedirectUrl = sessionStorage.getItem('successRedirectUrl');
      const baseURL = this.checkoutSuccessData.baseURL;

      if (successRedirectUrl && successRedirectUrl !== '' && successRedirectUrl !== 'null' && successRedirectUrl !== 'true' && (this.checkoutSuccessData.contract.status === 'ACTIVE' || this.checkoutSuccessData.contract.status === 'PAID' || this.classificationIdentifier === "descomplica")) {
        // if (successRedirectUrl.indexOf('/v2/recuperacao-de-dividas') > -1) {
        //   console.log('successRedirectUrl', successRedirectUrl);
        //   this.checkoutSuccessData.buttonCTA = 'Realizar consulta';
        //   this.checkoutSuccessData.redirectUrl = baseURL + 'v2/recuperacao-de-dividas';
        //   // this.buttonCTASecondary = 'Recuperação de dívidas';
        //   // this.redirectUrlSecondary = baseURL + 'v2/recuperacao-de-dividas';
        // }

        // this.checkoutSuccessData.buttonCTA = 'Realizar consulta';
        this.checkoutSuccessData.redirectUrl = successRedirectUrl;

        if (successRedirectUrl.indexOf('/cadastro/resgatar-senha') > -1) {
          const customer = JSON.parse(sessionStorage.getItem('customer'));
          const base64Email = btoa(customer.email);
          const pathLogado = this.classificationIdentifier.includes('saude') ? 'saude_deslog' : this.classificationIdentifier.includes('consulta') ? 'consulta_deslog' : 'monitoreClientes';
          const recoverPasswordURL = baseURL + 'cadastro/resgatar-senha' + '?username=' + base64Email + '&pathLogado=' + pathLogado;
          this.checkoutSuccessData.redirectUrl = recoverPasswordURL;
        }
      } else {
        successRedirectUrl = null;
      }

      if ((this.checkoutSuccessData.contract.status === 'PAID' || this.checkoutSuccessData.contract.status === 'ACTIVE' || this.checkoutSuccessData.contract.paymentMethod.identifier === "PIX")
        && this.checkoutSuccessData.contract.adobeAnalyticsData && this.checkoutSuccessData.contract.adobeAnalyticsData.firstPurchase) {

        let firstPurchaseUrlParam = '?firstPurchase=true';
        // Se já tem um parametro na url muda o ? para &
        if (this.checkoutSuccessData.redirectUrl.indexOf('?') > -1) {
          firstPurchaseUrlParam = '&firstPurchase=true';
        }
        this.checkoutSuccessData.redirectUrl += firstPurchaseUrlParam;
        if (this.redirectUrlSecondary) {
          this.redirectUrlSecondary += firstPurchaseUrlParam;
        }
      }

      if (this.checkoutSuccessData.contract.paymentMethod.identifier === 'BANK_BILLET') {
        this.totalValue = this.checkoutSuccessData.bankBilletData?.totalValue;
        this.couponAmount = this.checkoutSuccessData.bankBilletData?.discountedValue;
      } else if (this.checkoutSuccessData.contract.paymentMethod.identifier === 'PIX') {
        this.totalValue = this.checkoutSuccessData.pixData.totalValue;
        this.couponAmount = this.checkoutSuccessData.pixData.discountedValue;
      } else if (this.checkoutSuccessData.contract.paymentMethod.identifier === 'CREDIT_CARD') {
        this.totalValue = this.checkoutSuccessData?.creditCardData?.totalValue;
        this.couponAmount = this.checkoutSuccessData?.creditCardData?.discountedValue;
      }
      const trustConsultationData = this.sessionStorageService.getTrustConsultationData();
      if (trustConsultationData) {
        let trustConsultationParse = JSON.parse(trustConsultationData);
        const productValue = this.checkoutSuccessData.contract.product.value;
        const bonusAmount = this.checkoutSuccessData.bonusAmount || 0;
        this.finalBalanceTrust = productValue - trustConsultationParse.totalDebit + bonusAmount;
        this.totalDebitTrust = trustConsultationParse.totalDebit;
      }

      if (this.checkoutSuccessData.contract.status === 'ACTIVE' || this.checkoutSuccessData.contract.status === 'PAID') {
        if (this.checkoutSuccessData.contract.paymentMethod.identifier === 'CREDIT_CARD') {
          this.heroData = {
            type: 'success',
            title: 'Pagamento realizado com sucesso!',
            content: []
          };
        } else {
          this.heroData = {
            type: 'success',
            title: 'Pedido gerado com sucesso!',
            content: []
          };
        }
      } else if (this.checkoutSuccessData.pendingPaymentPurchase === true) {
        this.heroData = {
          type: 'warn',
          title: 'Estamos processando o seu pedido.',
          contents: ['Não se preocupe, você receberá um email informando se o seu pedido foi processado com sucesso ou não.', 'Por favor, aguarde.']
        };
      } else if (this.checkoutSuccessData.contract.status.includes("INVESTIGATED")) {
        this.heroData = {
          type: 'info',
          title: 'Estamos quase lá.',
          contents: [{ message: 'Recebemos o seu pedido e já iniciamos as próximas etapas: análise de dados e confirmação do pagamento.', bold: true }, 'Fique de olho no seu e-mail, em até 6 horas você receberá a atualização do status do seu pedido.']
        };
      } else {
        this.heroData = {
          type: 'success',
          title: 'Pedido gerado com sucesso!',
          content: []
        };

        // Venda deslogada - boleto
        if (successRedirectUrl && successRedirectUrl !== 'null' && successRedirectUrl.indexOf('/cadastro/resgatar-senha') > -1) {
          this.checkoutSuccessData.buttonCTA = 'Definir senha';
          const customer = JSON.parse(sessionStorage.getItem('customer'));
          const base64Email = btoa(customer.email);
          const pathLogado = this.classificationIdentifier.includes('saude') ? 'saude_deslog' : this.classificationIdentifier.includes('consulta') ? 'consulta_deslog' : 'monitoreClientes';
          const recoverPasswordURL = baseURL + 'cadastro/resgatar-senha' + '?username=' + base64Email + '&pathLogado=' + pathLogado;
          this.checkoutSuccessData.redirectUrl = recoverPasswordURL;
        }
      }

      if (sessionStorage.getItem('newCustomer')) {
        this.checkoutSuccessData.buttonCTA = 'Concluir cadastro';
        this.setRedirectUrl('cadastro/resgatar-senha' + '?businessId=' + this.businessId + '&userId=' + this.userId);
      } else if (this.classificationIdentifier === 'plano-mensal' && (!successRedirectUrl || successRedirectUrl === '')) {
        this.checkoutSuccessData.buttonCTA = 'Acessar meus produtos';
        this.checkoutSuccessData.redirectUrl += '?businessId=' + this.businessId + '&userId=' + this.userId;

        if (this.checkoutSuccessData.contract && this.checkoutSuccessData.contract.status.includes("INVESTIGATED")) {
          this.setRedirectUrl('v2/processando-pedido' + '?businessId=' + this.businessId + '&userId=' + this.userId);
        } else {
          this.setFromSydleUrlAttribute();
        }
      }
      let coupons;

      if (this.checkoutSuccessData.contract.paymentMethod.identifier === 'BANK_BILLET') {
        coupons = this.checkoutSuccessData.bankBilletData?.appliedCoupons
      } else if (this.checkoutSuccessData.contract.paymentMethod.identifier === 'CREDIT_CARD') {
        coupons = this.checkoutSuccessData.creditCardData?.appliedCoupons
      } else if (this.checkoutSuccessData.contract.paymentMethod.identifier === 'PIX') {
        coupons = this.checkoutSuccessData.pixData?.appliedCoupons;
      }

      if (coupons && coupons.length > 0) {
        coupons.forEach(coupon => {
          if (coupon.type === 'TRIAL') {
            coupon.trybuy = true;
          }
        });
      }



      let confirmationData = {
        orderId: this.checkoutSuccessData.contract.code,
        pagamento: this.checkoutSuccessData.contract.paymentMethod.identifier,
        orderEventId: this.checkoutSuccessData.creditCardData ?
          this.checkoutSuccessData.creditCardData.invoiceId : this.checkoutSuccessData.bankBilletData ?
            this.checkoutSuccessData.bankBilletData.invoiceId : this.checkoutSuccessData.pixData ?
              this.checkoutSuccessData.pixData.invoiceId : '',
        totalPrice: this.totalValue,
        amountPaid: this.totalValue,
        firstTime: this.checkoutSuccessData.contract.adobeAnalyticsData ? this.checkoutSuccessData.contract.adobeAnalyticsData.firstPurchase : null,
        orderType: this.checkoutSuccessData.contract.adobeAnalyticsData ? this.checkoutSuccessData.contract.adobeAnalyticsData.purchaseType : null,
        amountRemaining: this.checkoutSuccessData.contract.product.value ? this.checkoutSuccessData.contract.product.value - this.totalValue : 0,
        amountTotal: this.checkoutSuccessData.contract.product.value,
        coupon: this.checkoutSuccessData.getConcatenatedDiscounts(),
        mgmCoupon: this.checkoutSuccessData.contract.mgmCoupon,
        couponAmount: this.couponAmount,
        autoRecharge: this.checkoutSuccessData.contract.provisioningParameters.allowAutomaticRecharge === true,
        appliedCoupons: coupons,
        installments: this.checkoutSuccessData.contract.paymentMethod.identifier === 'CREDIT_CARD' ?
          this.checkoutSuccessData.contract.paymentMethod.paymentConditionIdentifier : null,
        purchaseStatus: this.checkoutSuccessData.contract.status,
        bonusAmount: this.checkoutSuccessData.bonusAmount || null,
        bonus: this.checkoutSuccessData.bonus || null,
        oneClick: this.checkoutSuccessData.oneClick || false,
        purchaseOrigin: this.checkoutSuccessData.purchaseOrigin || null,
        viewedRetentionModal: this.checkoutSuccessData.viewedRetentionModal || null,
        viewedCreditCardPaymentError: this.checkoutSuccessData.viewedCreditCardPaymentError || false,
        triggeredSecondaryCardAutoSelectFeature: this.checkoutSuccessData.triggeredSecondaryCardAutoSelectFeature || false
      };

      this.showHero = true;
      let classificationName = this.checkoutSuccessData.contract.product.classificationName;
      if (this.isTelevendas) {
        this.salesPerson = sessionStorage.getItem('salesPerson');
        if (this.salesPerson) {
          confirmationData["salesPerson"] = this.salesPerson;
        }
        let classificationNameMapTelevendas = {
          "Consulta e Cobrança de Dívidas": "PacotedeCreditoMPME-Televendas",
          "Saúde do seu Negócio": "SaudeFinanceira-Televendas",
          "Monitore Clientes": "Serasa-Monitora-Televendas"
        };
        classificationName = classificationNameMapTelevendas[classificationName] ? classificationNameMapTelevendas[classificationName] : classificationName;
      }

      let product = this.checkoutSuccessData.contract.product;
      if (product.classificationIdentifier === "plano-mensal-recarga-pontual") {
        product.classificationIdentifier = "assinatura-recarga-pontual";
      }
      let productFamilyIdentifier = this.checkoutSuccessData.contract.product.classificationIdentifier;

      this.checkoutService.getBalanceExpirationDate(productFamilyIdentifier)
        .subscribe({
          next: (res) => {
            this.balanceExpirationDate = res.daysToExpire;
          },
          error: (err) => {
            //     console.error("Erro ao buscar expiração:", err);
          }
        });
      this.dtmService.productsLoaded([{
        identifier: this.checkoutSuccessData.contract.product.identifier,
        classificationName: classificationName,
        quantity: 1,
        totalValue: this.totalValue,
        merchandising: product
      }]);

      this.dtmService.checkoutSuccess(confirmationData);

      if (confirmationData.oneClick) {
        this.dtmService.sendSydleCustomEvent("compraComUmClique", {
          "businessId": this.businessId || null,
          "userId": this.userId || null,
          "jorneyMappingEvent": "Compra com um clique efetuada"
        });
      }

      if (confirmationData.purchaseOrigin === "suggestionPackageModal") {
        this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
          "businessId": this.businessId || null,
          "userId": this.userId || null,
          "jorneyMappingEvent": "Compra efetuada a partir da modal"
        });
      }

      this.dtmService.sendPageLoadEvent('Purchase');
      this.clearSessionStorage();
    }
  }

  setRedirectUrl(targetUrl) {
    this.utils.returnBaseUrl().subscribe((result) => {
      this.checkoutSuccessData.redirectUrl = (result.serasaBaseUrl + targetUrl);
      this.setFromSydleUrlAttribute();
    });
  }

  setFromSydleUrlAttribute() {
    let fromSydle = '?fromSydle=true';
    if (this.checkoutSuccessData.redirectUrl.indexOf('?') > -1) {
      fromSydle = '&fromSydle=true';
    }

    this.checkoutSuccessData.redirectUrl += fromSydle;
  }

  onSuccessClick(ctaClicked: string) {
    if (this.checkoutSuccessData.contract.product.identifier === "pacote-20") {
      document.location.href = environment.redirect_consulta + "v2/consulta-serasa?firstPurchase=true";
      return;
    }


    if (ctaClicked === 'primary') {
      if (this.checkoutSuccessData.contract.product.classificationIdentifier === 'monitore-clientes') {
        this.checkPurchaseIntegrationStatus(this.checkoutSuccessData.contract.code)
          .then((integrationStatus) => {
            if (integrationStatus !== 'integrationSuccess') {
              this.openErrorIntegrationDialog(this.checkoutSuccessData.contract.product.classificationIdentifier);
            } else {
              this.dtmService.customClickEvent(this.checkoutSuccessData.buttonCTA);
              if (!sessionStorage.getItem('successRedirectUrl')) {
                document.location.href = this.checkoutSuccessData.redirectUrl + '?integrationStatus=' + integrationStatus;
              } else {
                document.location.href = this.checkoutSuccessData.redirectUrl;
              }
            }
          })
          .catch((error) => {
            this.openErrorIntegrationDialog(this.checkoutSuccessData.contract.product.classificationIdentifier);
          });
      } else {
        this.dtmService.customClickEvent(this.checkoutSuccessData.buttonCTA);
        document.location.href = this.checkoutSuccessData.redirectUrl;
      }
    } else if (ctaClicked === 'secondary') {
      this.dtmService.customClickEvent(this.buttonCTASecondary);
      document.location.href = this.redirectUrlSecondary;
    }

  }

  ngOnDestroy(): void {
    sessionStorage.clear();
    sessionStorage.removeItem('dataLayer');
    sessionStorage.removeItem('cart');
    sessionStorage.removeItem('customer');
    sessionStorage.removeItem('paymentMethod');
    sessionStorage.removeItem('businessId');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('category');
    sessionStorage.removeItem('product');
    sessionStorage.removeItem('currentStep');
    sessionStorage.removeItem('coupon');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('email');
    localStorage.removeItem('checkoutSuccessData');
    sessionStorage.removeItem('identificationCompleted');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('email');

    // Limpar cookies setados na vitrine híbrida
    this.cookieService.delete('userId');
    this.cookieService.delete('businessId');
    this.cookieService.delete('hybridPackageRedirect');

    document.location.href = this.checkoutSuccessData.redirectUrl;
  }

  getProvisioningParametersFromSessionStorage() {
    let sessionStorageValidationData;
    if (sessionStorage && (sessionStorage.getItem('validationData') || localStorage.getItem('validationData'))) {
      sessionStorageValidationData = JSON.parse(sessionStorage.getItem('validationData') || localStorage.getItem('validationData'));
      localStorage.setItem('validationData', JSON.stringify(sessionStorageValidationData));
    }
    this.userId = sessionStorageValidationData.userId ? sessionStorageValidationData.userId : (sessionStorage.getItem('userId') || localStorage.getItem('userId'));
    this.businessId = sessionStorageValidationData.businessId ? sessionStorageValidationData.businessId : (sessionStorage.getItem('businessId') || localStorage.getItem('businessId'));

    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID,
    });
  }

  clearSessionStorage() {
    // sessionStorage.clear();
    sessionStorage.removeItem('cart');
    sessionStorage.removeItem('customer');
    sessionStorage.removeItem('paymentMethod');
    sessionStorage.removeItem('businessId');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('currentStep');
    sessionStorage.removeItem('coupon');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('email');
    // Limpar cookies setados na vitrine híbrida
    this.cookieService.delete('userId');
    this.cookieService.delete('businessId');
    this.cookieService.delete('hybridPackageRedirect');

  }

  public checkPurchaseIntegrationStatus(contractCode: string): Promise<string> {
    return lastValueFrom(this.httpService.post('eCommercePME/eCommerceAPI/checkPurchaseIntegrationStatus', Api.One_Portal,
      {
        'contractCode': contractCode
      }))
      .then(result => {
        return result.integrationStatus;
      });
  }

  openErrorIntegrationDialog(productIdentifier) {
    const data = DialogData.fromPreset("processingPurchase");
    const errorMessage = data.errorMessage;

    this.dialog.open(DialogAlertComponent, {
      disableClose: false,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });

    // Analytics
    this.dtmService.customErrorLoaded(['errorPurchaseIntegration'], {
      errorDetail: productIdentifier,
      errorMessage: errorMessage,
    });
  }

}
